module.exports = __webpack_public_path__ + "static/media/dashImg.6fbf0d25.svg";